export default __webpack_public_path__ + "static/product_category_hardware-b6a1996777855bef0bac60e5d003153e.jpg";